__turbopack_context__.v({
  "container": "Logo-module__MSOgda__container",
  "fadeInItems": "Logo-module__MSOgda__fadeInItems",
  "logo": "Logo-module__MSOgda__logo",
  "spacing--lg": "Logo-module__MSOgda__spacing--lg",
  "spacing--md": "Logo-module__MSOgda__spacing--md",
  "spacing--sm": "Logo-module__MSOgda__spacing--sm",
  "spacing--xl": "Logo-module__MSOgda__spacing--xl",
  "spacing--xs": "Logo-module__MSOgda__spacing--xs",
  "spacing--xxl": "Logo-module__MSOgda__spacing--xxl",
  "spacing--xxs": "Logo-module__MSOgda__spacing--xxs",
  "spacing--xxxl": "Logo-module__MSOgda__spacing--xxxl",
  "spacing--xxxs": "Logo-module__MSOgda__spacing--xxxs",
});
